import { useCallback, useEffect, useRef, useState } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwButton from "../../shared/OwButton/OwButton";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IOwTableCols from "../../../models/IOwTableCols";
import IDaily_Route from "../../../models/IDaily_Route";
import IDaily_Route_Order_Map from "../../../models/IDaily_Route_Order_Map";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../models/EndpointsEnum";
import UserTypesEnum from "../../../models/UserTypesEnum";
import IOnGetDailyRoutesDTO from "../../../models/DTO/IOnGetDailyRoutesDTO";
import { OwFnTable } from "../../shared/OwFnTable/OwFnTable";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwIconTooltip } from "../../shared/OwIconTooltip/OwIconTooltip";
import { TypeaheadFn } from "../../shared/TypeaheadFn/TypeaheadFn";
import IConnection_Token from "../../../models/IConnection_Token";
import ITypeaheadLookupByTokenTypeDTO from "../../../models/DTO/ITypeaheadLookupByTokenTypeDTO";
import TokenTypesEnum from "../../../models/TokenTypesEnum";
import IOnTypeaheadLookupByTokenTypeDTO from "../../../models/DTO/IOnTypeaheadLookupByTokenTypeDTO";
import OwDateRange from "../../shared/OwDateRange/OwDateRange";
import { Moment } from "moment-timezone";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import { DailyRouteSidebar } from "../DailyRouteSidebar/DailyRouteSidebar";
import { DailyRouteMapModal } from "../DailyRouteMapModal/DailyRouteMapModal";
import { DailyRouteAppLearnMoreModal } from "../DailyRouteAppLearnMoreModal/DailyRouteAppLearnMoreModal";
import moment from "moment";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import IProcessDailyRouteDTO from "../../../models/DTO/IProcessDailyRouteDTO";
import { Link, useNavigate } from "react-router-dom";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import IOptimizeDailyRouteDTO from "../../../models/DTO/IOptimizeDailyRouteDTO";
import IOnOptimizeDailyRouteDTO from "../../../models/DTO/IOnOptimizeDailyRouteDTO";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import * as _ from "lodash-es";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { SearchSection } from "../../shared/SearchSection/SearchSection";
import { useAppContextNonNull } from "@contexts/AppContext";
import RestEndpointsEnum from "../../../models/RestEndpointsEnum";
import { buildRestUrl, buildRestUrlWithQuery, buildAuthHeadersForFetch } from "../../../services/RestService";
import IBaseOnGetCsvDataDTO from "../../../models/DTO/IBaseOnGetCsvDataDTO";
import UIService from "../../../services/UIService";
import IRoute from "../../../models/IRoute";
import IUser from "../../../models/IUser";
import IVehicle from "../../../models/IVehicle";
import IGetRoutesDTO from "../../../models/DTO/IGetRoutesDTO";
import IOnGetRoutesDTO from "../../../models/DTO/IOnGetRoutesDTO";
import IOnGetVehiclesDTO from "../../../models/DTO/IOnGetVehiclesDTO";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import OwCheckbox from "@components/shared/OwCheckbox/OwCheckbox";
import OwActionBar from "@components/shared/OwActionBar/OwActionBar";
import IAction from "@models/IAction";
import { startCase } from "lodash-es";
import SortOrderEnum from "@models/SortOrderEnum";
import UserService from "@services/UserService";
import { getFilterBarMode } from "@utils/filterBarVersion";
import { FilterBarVersionToggle } from "@components/shared/FilterBarVersionToggle/FilterBarVersionToggle";
import { IDailyRoutesFilterQuery } from "@config/filters/dailyRoutesFilters";
import { DailyRoutesFilterBar, DAILY_ROUTES_FILTER_ACTIONS_ID } from "./DailyRoutesFilterBar/DailyRoutesFilterBar";

type Props = {};

export const DailyRoutes = (props: Props) => {
    const { supplierModel, userModel, uiContext, socket } = useAppContextNonNull();
    const navigate = useNavigate();

    // FilterBar (v2) ships behind the per-user toggle; its query is kept here and merged into the REST query.
    const usesFilterBarV2 = getFilterBarMode(UserService.getCurrentToken(userModel)?.settings).useFilterBar;
    const filterBarQueryRef = useRef<IDailyRoutesFilterQuery>({});
    // Both the sort and the pagination effects fetch on mount; in v2 the FilterBar owns the initial search.
    const isMountSortFetch = useRef(true);
    const isMountFetch = useRef(true);

    const getBreadcrumbs = () => {
        return [
            {
                title: "daily_routes",
                url: "/daily_routes",
            },
        ];
    };

    const openDailyRoutesSidebar = (row?: IDaily_Route) => {
        const sideBarComponent = <DailyRouteSidebar cancelFn={cancelSidebar} dailyRoute={row} />;

        uiContext.setSidebarComponent(sideBarComponent);
        uiContext.toggleSidebar(true);
    };

    const cancelSidebar = (refresh?: boolean) => {
        if (refresh) {
            getDailyRoutes();
        }

        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);
    };

    const showDeleteConfirm = (row: IDaily_Route, index: number) => {
        setTargetElem(`row-${index}`);
        setSelectedDailyRoute(row);
    };

    const renderDriver = (row: IDaily_Route) => {
        return <div>{row.Driver?.name || "-"}</div>;
    };

    const renderRoute = (row: IDaily_Route, index: number) => {
        return <div className={"d-flex align-items-center"}>{row.Route?.name}</div>;
    };

    const renderStatus = (row: IDaily_Route) => {
        const status = startCase(row.status?.replaceAll("_", " "));
        const statusClass = row.status === "completed" ? "text-success" : row.status === "in_progress" ? "text-warning" : "text-danger";

        return <div className={statusClass}>{status}</div>;
    };

    const renderUser = (row: IDaily_Route) => {
        return <div>{row.User?.name}</div>;
    };

    const renderRouteDate = (row: IDaily_Route) => {
        return <div>{moment(row.route_date).format("MM/DD/YYYY")}</div>;
    };

    const renderVehicle = (row: IDaily_Route) => {
        return <div>{row.Vehicle?.name || "-"}</div>;
    };

    const renderOrders = (row: IDaily_Route) => {
        // Sort by optimized_order_seq whenever set — manual reordering reuses it
        // without setting is_optimized. Null/-1 sort last, name tiebreak.
        const seqOf = (map: IDaily_Route_Order_Map) =>
            _.isNil(map.optimized_order_seq) || map.optimized_order_seq === -1 ? Number.MAX_SAFE_INTEGER : map.optimized_order_seq;
        const nameOf = (map: IDaily_Route_Order_Map) => map.Order?.name || map.Vendor?.name || "";

        const ordersMap = [...(row.Daily_Route_Order_Maps || [])].sort((a, b) => seqOf(a) - seqOf(b) || nameOf(a).localeCompare(nameOf(b)));

        return (
            <div className="no-wrap">
                {ordersMap.map((routeMap) => {
                    if (routeMap.Order) {
                        return (
                            <div key={`order-${routeMap.Order.guid}`}>
                                <Link to={`/orders/${routeMap.Order.guid}/entry`}>{routeMap.Order.name}</Link>
                            </div>
                        );
                    }

                    // Order-less customer stop (van-sell DSD) — identity comes from the stop-level Vendor
                    return <div key={`vendor-${routeMap.Vendor?.guid}`}>{routeMap.Vendor?.name}</div>;
                })}
            </div>
        );
    };

    const optimizeDailyRoute = (row: IDaily_Route) => {
        const activeMap = { ...optimizeActiveMap };
        activeMap[row.guid] = true;
        console.log(activeMap);
        setOptimizeActiveMap(activeMap);

        const payload: IOptimizeDailyRouteDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            dailyRouteGuid: row.guid,
        };

        socket.emit(EndpointsEnum.RoutesOptimizeDailyRoute, payload);

        uiContext.setActivityIndicator(true);
    };

    const onOptimizeDailyRoute = (data: IOnOptimizeDailyRouteDTO) => {
        uiContext.setActivityIndicator(false);

        const notification: INotification = {
            message: "successfully_optimized_daily_route",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        uiContext.notifyFn(null, notification);

        getDailyRoutes();
    };

    const getIsActive = (row: IDaily_Route): boolean => {
        const active = optimizeActiveMap[row.guid];
        return active;
    };

    const renderOptimize = (row: IDaily_Route) => {
        if (row.status !== "not_started") {
            return null;
        }

        if ((row.Daily_Route_Order_Maps || []).length < 3) {
            return (
                <div>
                    <OwLabel title={"unavailable"} leftIconClass={"fad fa-exclamation-triangle"} leftIconTitle={"less_than_three_orders"} />
                    <OwIconTooltip
                        iconClassName={"fad fa-info-circle ms-2"}
                        tooltipContent={"less_than_three_orders"}
                        translateContent={true}
                    />
                </div>
            );
        } else {
            return row.is_optimized ? (
                <div className={"text-success"}>
                    <OwLabel title={"optimized"} leftIconClass={"fad fa-truck-fast"} />

                    <OwButton
                        title={"optimize"}
                        fn={() => {
                            optimizeDailyRoute(row);
                        }}
                        active={getIsActive(row)}
                        disableOnActive={true}
                    />
                </div>
            ) : (
                <OwButton
                    title={"optimize"}
                    fn={() => {
                        optimizeDailyRoute(row);
                    }}
                    active={getIsActive(row)}
                    disableOnActive={true}
                />
            );
        }
    };

    const createPackingLists = (row: IDaily_Route) => {
        navigate(`/routes/daily/packing_list?dailyRoutes=${row.guid}`);
    };

    const createPickLists = (row: IDaily_Route) => {
        navigate(`/routes/daily/pick_list?dailyRoutes=${row.guid}`);
    };

    /** One Sales Order per order on the route, printed as a batch. */
    const createSalesOrders = (row: IDaily_Route) => {
        navigate(`/routes/daily/sales_order?dailyRoutes=${row.guid}`);
    };

    /** One Invoice per order on the route, printed as a batch. */
    const createInvoices = (row: IDaily_Route) => {
        navigate(`/routes/daily/invoice?dailyRoutes=${row.guid}`);
    };

    /** Printable audit report (timestamps, GPS vs customer location, proof of delivery). */
    const openAuditReport = (row: IDaily_Route) => {
        navigate(`/routes/daily/${row.guid}/audit`);
    };

    const downloadOptimizedRouteCsv = async (row: IDaily_Route) => {
        const url = buildRestUrl({
            endpoint: RestEndpointsEnum.DailyRouteCSV,
            params: { dailyRouteGuid: row.guid },
        });

        const headers = buildAuthHeadersForFetch({
            userModel,
            supplierModel,
        });

        try {
            const response = await fetch(url, { method: "GET", headers });
            if (response.ok) {
                const data: IBaseOnGetCsvDataDTO = await response.json();
                UIService.downloadCSVData(data.csvData, data.filename);
            } else {
                console.error("Failed to download CSV:", response.statusText);
            }
        } catch (error) {
            console.error("Error downloading CSV:", error);
        }
    };

    const viewOptimizedRouteMap = (row: IDaily_Route) => {
        setSelectedRouteForMap(row);
        setShowMapModal(true);
    };

    const [selectedDailyRoute, setSelectedDailyRoute] = useState<IDaily_Route | undefined>();
    const [selectedDailyRoutes, setSelectedDailyRoutes] = useState<{ [id: number]: boolean }>({});
    const selectedDailyRoutesRef = useRef(selectedDailyRoutes);
    selectedDailyRoutesRef.current = selectedDailyRoutes;

    const [sortCol, setSortCol] = useState<string | undefined>("name");
    const [sortOrder, setSortOrder] = useState<SortOrderEnum>(SortOrderEnum.DESC);

    const renderActions = useCallback(
        (row: IDaily_Route, index: number) => {
            return (
                <div className="d-flex align-items-center">
                    <OwCheckbox
                        checked={selectedDailyRoutesRef.current[row.id]}
                        fn={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setSelectedDailyRoutes((prev) => ({ ...prev, [row.id]: e.target.checked }));
                        }}
                        name={"selectedDailyRoutes"}
                        className={"me-2"}
                    />
                    <OwDeleteEditActions
                        isEditMode={false}
                        onTrashClickFn={() => {
                            showDeleteConfirm(row, index);
                        }}
                        onEditClickFn={() => {
                            openDailyRoutesSidebar(row);
                        }}
                        className={"me-2"}
                    />
                    <Dropdown as={ButtonGroup} data-bs-theme="dark">
                        <Dropdown.Toggle size="sm" variant="secondary">
                            <OwLabel title="actions" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {/* These should be conditional I think if they have the managed pick / pack */}
                            <Dropdown.Item onClick={() => createPickLists(row)}>
                                <i className="fas fa-clipboard-list me-2" />
                                <OwLabel title="pick_list" className="pointer" />
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => createPackingLists(row)}>
                                <i className="fas fa-boxes me-2" />
                                <OwLabel title="packing_lists" className="pointer" />
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => createSalesOrders(row)}>
                                <i className="fas fa-file-alt me-2" />
                                <OwLabel title="sales_order" className="pointer" />
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => createInvoices(row)}>
                                <i className="fas fa-file-invoice-dollar me-2" />
                                <OwLabel title="invoice" className="pointer" />
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => downloadOptimizedRouteCsv(row)}>
                                <i className="fas fa-download me-2" />
                                <OwLabel
                                    title={row.is_optimized ? "download_optimized_route_csv" : "download_route_csv"}
                                    className="pointer"
                                />
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => viewOptimizedRouteMap(row)}>
                                <i className="fas fa-map me-2" />
                                <OwLabel title="view_route_map" className="pointer" />
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => openAuditReport(row)}>
                                <i className="fas fa-clipboard-check me-2" />
                                <OwLabel title="audit_report" className="pointer" />
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    {supplierModel.has_daily_route_app && (
                        <div className="ms-2">
                            <Link to={`/routes/daily/${row.guid}/detail`}>
                                <OwLabel title="daily_route_detail" className="pointer" />
                            </Link>
                        </div>
                    )}
                </div>
            );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const [dailyRoutes, setDailyRoutes] = useState<IDaily_Route[]>([]);

    const selectAllFn = useCallback(
        (selectAll: boolean) => {
            const newSelected: { [id: number]: boolean } = {};
            for (const dailyRoute of dailyRoutes) {
                newSelected[dailyRoute.id] = selectAll;
            }
            setSelectedDailyRoutes(newSelected);
        },
        [dailyRoutes]
    );

    const getTableCols = (): IOwTableCols[] => {
        const columns: IOwTableCols[] = [
            {
                isActionsCol: true,
                title: "",
                valueProp: "actions",
                renderFn: renderActions,
                renderFnEmitsRow: true,
                hasSelectAll: true,
                selectAllFn: selectAllFn,
            },
            {
                title: "name",
                valueProp: "name",
                isSortable: true,
                sortFn: (col: string, order: SortOrderEnum) => {
                    setSortCol(col);
                    setSortOrder(order);
                },
                sortOrderFn: () => {
                    return sortOrder;
                },
            },
            {
                title: "route_date",
                valueProp: "route_date",
                renderFn: renderRouteDate,
                renderFnEmitsRow: true,
                isSortable: true,
                sortFn: (col: string, order: SortOrderEnum) => {
                    setSortCol(col);
                    setSortOrder(order);
                },
                sortOrderFn: () => {
                    return sortOrder;
                },
            },
            {
                title: "route",
                valueProp: "name",
                renderFn: renderRoute,
                renderFnEmitsRow: true,
                isSortable: true,
                sortCol: "route_name",
                sortFn: (col: string, order: SortOrderEnum) => {
                    setSortCol("route_name");
                    setSortOrder(order);
                },
                sortOrderFn: () => {
                    return sortOrder;
                },
            },
            {
                title: "status",
                valueProp: "status",
                renderFn: renderStatus,
                renderFnEmitsRow: true,
                isSortable: true,
                sortFn: (col: string, order: SortOrderEnum) => {
                    setSortCol(col);
                    setSortOrder(order);
                },
                sortOrderFn: () => {
                    return sortOrder;
                },
            },
            {
                title: "driver",
                valueProp: "name",
                renderFn: renderDriver,
                renderFnEmitsRow: true,
                isSortable: true,
                sortCol: "driver_name",
                sortFn: (col: string, order: SortOrderEnum) => {
                    setSortCol("driver_name");
                    setSortOrder(order);
                },
                sortOrderFn: () => {
                    return sortOrder;
                },
            },
        ];

        if (supplierModel.has_vehicles) {
            columns.push({
                title: "vehicle",
                valueProp: "vehicle",
                renderFn: renderVehicle,
                renderFnEmitsRow: true,
                isSortable: true,
                sortCol: "vehicle_name",
                sortFn: (col: string, order: SortOrderEnum) => {
                    setSortCol("vehicle_name");
                    setSortOrder(order);
                },
                sortOrderFn: () => {
                    return sortOrder;
                },
            });
        }

        columns.push(
            {
                title: "orders",
                valueProp: "orders",
                renderFn: renderOrders,
                renderFnEmitsRow: true,
            },
            {
                title: "optimized",
                valueProp: "optimized",
                renderFn: renderOptimize,
                renderFnEmitsRow: true,
            },
            {
                title: "created_by",
                valueProp: "name",
                renderFn: renderUser,
                renderFnEmitsRow: true,
            }
        );

        return columns;
    };

    useEffect(() => {
        console.log("sortCol: ", sortCol);
        console.log("sortOrder: ", sortOrder);

        document.title = "Orderwerks >> Daily Routes";

        if (isMountSortFetch.current) {
            isMountSortFetch.current = false;

            if (usesFilterBarV2) {
                // The FilterBar runs the initial search (default preset / baseline / deep link).
                return;
            }
        }

        getDailyRoutes();
    }, [sortCol, sortOrder]);

    const [crumbs, setCrumbs] = useState<IBreadcrumbs[]>(getBreadcrumbs());

    const [tableCols, setTableCols] = useState(getTableCols());

    // Update table columns when renderActions or selectAllFn change
    useEffect(() => {
        setTableCols(getTableCols());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [renderActions, selectAllFn]);

    const [isDataFetching, setIsDataFetching] = useState(true);
    const [isInitialData, setIsInitialData] = useState(true);
    const [totalDailyRoutes, setTotalDailyRoutes] = useState<number>(0);
    const [availableUsers, setAvailableUsers] = useState<IUser[]>([]);
    const [userFilter, setUserFilter] = useState<IUser | undefined>();
    const [resetTypeahead, setResetTypeahead] = useState(false);

    const [startDate, setStartDate] = useState<Moment | null>(null);
    const [endDate, setEndDate] = useState<Moment | null>(null);

    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(25);

    const [targetElem, setTargetElem] = useState<string | null>(null);

    const [optimizeActiveMap, setOptimizeActiveMap] = useState<{ [key: string]: boolean }>({});

    const [showMapModal, setShowMapModal] = useState(false);
    const [selectedRouteForMap, setSelectedRouteForMap] = useState<IDaily_Route | null>(null);

    // Route filter
    const [availableRoutes, setAvailableRoutes] = useState<IRoute[]>([]);
    const [routeFilter, setRouteFilter] = useState<IRoute | undefined>();
    const [resetRouteTypeahead, setResetRouteTypeahead] = useState(false);

    // Driver filter
    const [availableDrivers, setAvailableDrivers] = useState<IUser[]>([]);
    const [driverFilter, setDriverFilter] = useState<IUser | undefined>();
    const [resetDriverTypeahead, setResetDriverTypeahead] = useState(false);

    // Vehicle filter (conditional on has_vehicles)
    const [availableVehicles, setAvailableVehicles] = useState<IVehicle[]>([]);
    const [vehicleFilter, setVehicleFilter] = useState<IVehicle | undefined>();
    const [resetVehicleTypeahead, setResetVehicleTypeahead] = useState(false);

    // Order filter (simple text input)
    const [orderFilter, setOrderFilter] = useState<string>("");

    // Name filter (simple text input)
    const [nameFilter, setNameFilter] = useState<string>("");

    const noRoutesSelected = () => Object.values(selectedDailyRoutes).every((value) => value === false);

    const actions: IAction[] = [
        {
            name: "delivery_matrix",
            fn: () => {
                // compile all of the guids using the selectedDailyRoutes and dailyRoutes and create the navigation url
                const guids = dailyRoutes.filter((route) => selectedDailyRoutes[route.id]).map((route) => route.guid);

                navigate(`/routes/daily/delivery_matrix?dailyRouteGuids=${guids.join(",")}`);
            },
            disabledFn: () => noRoutesSelected(),
        },
        {
            name: "documents",
            isDropdownGroup: true,
            groupActions: [
                {
                    name: "pick_list",
                    leftIconClass: "fas fa-clipboard-list",
                    fn: () => {
                        const selectedGuids = dailyRoutes.filter((route) => selectedDailyRoutes[route.id]).map((route) => route.guid);
                        if (selectedGuids.length > 0) {
                            navigate(`/routes/daily/pick_list?dailyRoutes=${selectedGuids.join(",")}`);
                        }
                    },
                    disabledFn: () => noRoutesSelected(),
                },
                {
                    name: "packing_lists",
                    leftIconClass: "fas fa-boxes",
                    fn: () => {
                        const selectedGuids = dailyRoutes.filter((route) => selectedDailyRoutes[route.id]).map((route) => route.guid);
                        if (selectedGuids.length > 0) {
                            navigate(`/routes/daily/packing_list?dailyRoutes=${selectedGuids.join(",")}`);
                        }
                    },
                    disabledFn: () => noRoutesSelected(),
                },
                {
                    // One Sales Order per order on the selected routes, printed as a batch.
                    name: "sales_order",
                    leftIconClass: "fas fa-file-alt",
                    fn: () => {
                        const selectedGuids = dailyRoutes.filter((route) => selectedDailyRoutes[route.id]).map((route) => route.guid);
                        if (selectedGuids.length > 0) {
                            navigate(`/routes/daily/sales_order?dailyRoutes=${selectedGuids.join(",")}`);
                        }
                    },
                    disabledFn: () => noRoutesSelected(),
                },
                {
                    // One Invoice per order on the selected routes, printed as a batch.
                    name: "invoice",
                    leftIconClass: "fas fa-file-invoice-dollar",
                    fn: () => {
                        const selectedGuids = dailyRoutes.filter((route) => selectedDailyRoutes[route.id]).map((route) => route.guid);
                        if (selectedGuids.length > 0) {
                            navigate(`/routes/daily/invoice?dailyRoutes=${selectedGuids.join(",")}`);
                        }
                    },
                    disabledFn: () => noRoutesSelected(),
                },
            ],
        },
    ];

    const getDailyRoutes = async (overrides?: { skipAllFilters?: boolean }) => {
        setIsDataFetching(true);

        const query: Record<string, any> = { limit, offset };

        if (!overrides?.skipAllFilters) {
            if (usesFilterBarV2) {
                // FilterBar (v2): the emitted query is already keyed by the IGetDailyRoutesDTO field names.
                for (const [key, value] of Object.entries(filterBarQueryRef.current)) {
                    if (value !== undefined && value !== null && value !== "") {
                        query[key] = value;
                    }
                }
            } else {
                // Apply filters only if not skipping
                if (routeFilter) query.routeGuid = routeFilter.guid;
                if (driverFilter) query.routeDriverUserGuid = driverFilter.guid;
                if (vehicleFilter) query.vehicleGuid = vehicleFilter.guid;
                if (orderFilter.trim()) query.orderName = orderFilter.trim();
                if (userFilter) query.routeUserGuid = userFilter?.guid;
                if (startDate && endDate) {
                    query.startDate = startDate.format("YYYY-MM-DD");
                    query.endDate = endDate.format("YYYY-MM-DD");
                }
                if (nameFilter.trim()) query.name = nameFilter.trim();
            }
        }

        // Non-admin supplier users can only see their own routes
        if (userModel.isSupplierUser && userModel.supplierUserToken?.user_type_id !== UserTypesEnum.ADMIN) {
            query.routeUserGuid = userModel.guid;
        }

        if (sortCol) query.order_by = sortCol;
        if (sortOrder) query.order_dir = sortOrder;

        const url = buildRestUrlWithQuery({
            endpoint: RestEndpointsEnum.DailyRoutes,
            query,
        });

        const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

        try {
            const response = await fetch(url, { method: "GET", headers });
            const data: IOnGetDailyRoutesDTO = await response.json();

            const activeMap: { [key: string]: boolean } = {};
            for (const route of data.dailyRoutes) {
                activeMap[route.guid] = false;
            }
            setOptimizeActiveMap(activeMap);

            setDailyRoutes(data.dailyRoutes);
            setTotalDailyRoutes(data.totalDailyRoutes);

            setSelectedDailyRoutes({});
        } catch (error) {
            console.error("Error fetching daily routes:", error);
        } finally {
            setIsDataFetching(false);
            setIsInitialData(false);
        }
    };

    const lookupUser = (name: string) => {
        console.log("lookupUser: ", name);

        const payload: ITypeaheadLookupByTokenTypeDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            name,
            tokenType: TokenTypesEnum.SUPPLIER_USER,
        };

        socket.emit(EndpointsEnum.TokenTypeaheadLookupByTokenType, payload);
    };

    const onLookupByTokenType = (data: IOnTypeaheadLookupByTokenTypeDTO) => {
        setAvailableUsers(data.results.map((t) => t.User).filter(Boolean) as IUser[]);
    };

    // Route lookup (WebSocket)
    const lookupRoute = (name: string) => {
        if (!name.trim()) {
            setAvailableRoutes([]);
            return;
        }
        const payload: IGetRoutesDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            name,
            limit: 10,
        };
        socket.emit(EndpointsEnum.RoutesGetRoutes, payload);
    };

    const onGetRoutes = (data: IOnGetRoutesDTO) => {
        setAvailableRoutes(data.routes);
    };

    const searchUsers = async (name: string) => {
        if (!name.trim()) {
            setAvailableUsers([]);
            return;
        }

        const url = buildRestUrlWithQuery({
            endpoint: RestEndpointsEnum.TokensSearch,
            query: {
                tokenType: TokenTypesEnum.SUPPLIER_USER,
                name,
                limit: 10,
            },
        });

        const headers = buildAuthHeadersForFetch({
            userModel,
            supplierModel,
        });

        try {
            const response = await fetch(url, { method: "GET", headers });
            if (response.ok) {
                const data = (await response.json()) as IOnTypeaheadLookupByTokenTypeDTO;
                setAvailableUsers(data.results.map((t) => t.User).filter(Boolean) as IUser[]);
            }
        } catch (error) {
            console.error("Error searching users:", error);
            setAvailableUsers([]);
        }
    };

    // Driver lookup (REST)
    const lookupDriver = async (name: string) => {
        if (!name.trim()) {
            setAvailableDrivers([]);
            return;
        }
        const url = buildRestUrlWithQuery({
            endpoint: RestEndpointsEnum.TokensSearch,
            query: {
                tokenType: TokenTypesEnum.SUPPLIER_USER,
                name,
                limit: 10,
            },
        });
        const headers = buildAuthHeadersForFetch({ userModel, supplierModel });
        try {
            const response = await fetch(url, { method: "GET", headers });
            const data = (await response.json()) as IOnTypeaheadLookupByTokenTypeDTO;
            setAvailableDrivers((data.results || []).map((t) => t.User).filter(Boolean) as IUser[]);
        } catch (error) {
            console.error("Error searching drivers:", error);
            setAvailableDrivers([]);
        }
    };

    // Vehicle lookup (REST)
    const lookupVehicle = async (name: string) => {
        if (!name.trim()) {
            setAvailableVehicles([]);
            return;
        }
        const url = buildRestUrlWithQuery({
            endpoint: RestEndpointsEnum.GetVehicles,
            query: { name, limit: 10 },
        });
        const headers = buildAuthHeadersForFetch({ userModel, supplierModel });
        try {
            const response = await fetch(url, { method: "GET", headers });
            const data: IOnGetVehiclesDTO = await response.json();
            setAvailableVehicles(data.vehicles || []);
        } catch (error) {
            console.error("Error searching vehicles:", error);
            setAvailableVehicles([]);
        }
    };

    const onProcessDailyRoute = () => {
        setSelectedDailyRoute(undefined);
        setTargetElem(null);
        getDailyRoutes();
    };

    const notify = () => {
        uiContext.setActivityIndicator(false);

        // Clear any in-flight optimize state so the row's button stops showing active on error.
        setOptimizeActiveMap((prev) => {
            const cleared: { [key: string]: boolean } = {};
            for (const key of Object.keys(prev)) {
                cleared[key] = false;
            }
            return cleared;
        });
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.RoutesOnGetRoutes, fn: onGetRoutes },
        { endpoint: EndpointsEnum.TokenOnTypeaheadLookupByTokenType, fn: onLookupByTokenType },
        { endpoint: EndpointsEnum.RoutesOnProcessDailyRoute, fn: onProcessDailyRoute },
        { endpoint: EndpointsEnum.RoutesOnOptimizeDailyRoute, fn: onOptimizeDailyRoute },
        { endpoint: EndpointsEnum.Notify, fn: notify },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        if (isMountFetch.current) {
            isMountFetch.current = false;

            if (usesFilterBarV2) {
                // The FilterBar runs the initial search (default preset / baseline / deep link).
                return;
            }
        }

        getDailyRoutes();
    }, [offset, limit]);

    const selectedUser = (user: IUser) => {
        setUserFilter(user);
    };

    const renderAvailableUsers = (row: IUser) => {
        return <div>{row?.name}</div>;
    };

    // Enter key handler for search
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter") {
            getDailyRoutes();
        }
    };

    const resetSearch = () => {
        // Reset existing filters
        setAvailableUsers([]);
        setUserFilter(undefined);
        setResetTypeahead(true);
        setStartDate(null);
        setEndDate(null);

        // Reset new filters
        setAvailableRoutes([]);
        setRouteFilter(undefined);
        setResetRouteTypeahead(true);

        setAvailableDrivers([]);
        setDriverFilter(undefined);
        setResetDriverTypeahead(true);

        setAvailableVehicles([]);
        setVehicleFilter(undefined);
        setResetVehicleTypeahead(true);

        setOrderFilter("");
        setNameFilter("");

        getDailyRoutes({ skipAllFilters: true });
    };

    /** FilterBar (v2) search: remember the query, go back to page 1, and fetch. */
    const filterDailyRoutes = (query: IDailyRoutesFilterQuery) => {
        filterBarQueryRef.current = query;

        if (offset !== 0) {
            // The pagination effect re-runs getDailyRoutes() with the new offset.
            setOffset(0);
        } else {
            getDailyRoutes();
        }
    };

    // The legacy / v2 toggle reloads the user model, so this component re-renders (not remounts) with the
    // other search UI. Switching to v2 is covered by the FilterBar's own mount search; switching back to
    // legacy has to clear the v2 query itself, or the table keeps showing the last v2 results.
    const prevUsesFilterBarV2 = useRef(usesFilterBarV2);

    useEffect(() => {
        if (prevUsesFilterBarV2.current === usesFilterBarV2) {
            return;
        }

        prevUsesFilterBarV2.current = usesFilterBarV2;
        filterBarQueryRef.current = {};

        if (!usesFilterBarV2) {
            resetSearch();
        }
    }, [usesFilterBarV2]);

    const onPaginationChanged = (_offset: number, _limit: number) => {
        setOffset(_offset);
        setLimit(_limit);
    };

    const handleConfirm = () => {
        if (selectedDailyRoute) {
            const payload: IProcessDailyRouteDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                dailyRoutes: [
                    {
                        dailyRoute: {
                            ...selectedDailyRoute,
                        },
                        deleteFlag: true,
                    },
                ],
            };

            socket.emit(EndpointsEnum.RoutesProcessDailyRoute, payload);
        }
    };

    const handleCancel = () => {
        setTargetElem(null);
    };

    const renderMapModal = () => {
        return <DailyRouteMapModal dailyRoute={selectedRouteForMap} show={showMapModal} onHide={() => setShowMapModal(false)} />;
    };

    const openDailyRouteAppLearnMoreModal = () => {
        const modalComponent = <DailyRouteAppLearnMoreModal closeModalFn={closeDailyRouteAppModal} />;
        uiContext.setModalSetup({
            modalContentClass: "modalContentClass modal-dialog-centered modal-fit-content",
            modalOverlayClass: "modalOverlayClass d-flex align-items-center",
        });
        uiContext.setModalComponent(modalComponent);
        uiContext.showModal(true);
    };

    const closeDailyRouteAppModal = () => {
        uiContext.resetModalClassesAndStyles();
        uiContext.setModalComponent(null);
        uiContext.showModal(false);
    };

    return (
        <div className={"DailyRoutes position-relative"} id={"daily_routes"}>
            <div className="row mt-2">
                <div className={"col-12 d-flex justify-content-between align-items-center"}>
                    <div className="d-flex align-items-center">
                        <OwTitle title={"daily_routes"} leftIconName={"fad fa-map-marked-alt"} />
                        <div>
                            <OwButton
                                className={"ms-2 btn-warning"}
                                title={"create"}
                                leftIconClass={"fas fa-plus"}
                                fn={() => {
                                    openDailyRoutesSidebar();
                                }}
                            />
                        </div>
                    </div>
                    {/* Legacy / FilterBar (v2) search toggle, and the portal target for the v2 Refresh + Filters buttons */}
                    <div className={"ms-auto me-2 d-flex align-items-center"}>
                        <FilterBarVersionToggle />
                        <div id={DAILY_ROUTES_FILTER_ACTIONS_ID} className={"d-flex align-items-center ms-2 d-print-none"} />
                    </div>
                    {!supplierModel.has_daily_route_app && (
                        <div>
                            <OwButton
                                leftIconClass="fas fa-info-circle"
                                title="daily_route_app_learn_more"
                                fn={openDailyRouteAppLearnMoreModal}
                            />
                        </div>
                    )}
                </div>
            </div>

            {/* FilterBar (v2) search, behind the per-user toggle */}
            {usesFilterBarV2 && (
                <div className={"mb-2"}>
                    <DailyRoutesFilterBar isSearching={isDataFetching} searchFn={filterDailyRoutes} />
                </div>
            )}

            {/* Legacy search */}
            {!usesFilterBarV2 && (
                <div className={"mb-2"}>
                    <SearchSection>
                        <div className={"row"}>
                            {/* Name Filter (simple text input) */}
                            <div className={"col-12 col-md-2"} onKeyDown={handleKeyDown}>
                                <div>
                                    <OwLabel title={"name"} />
                                </div>
                                <OwFnInput
                                    name="nameFilter"
                                    value={nameFilter}
                                    fn={(e: React.ChangeEvent<HTMLInputElement>) => setNameFilter(e.target.value)}
                                />
                            </div>

                            {/* Route Filter */}
                            <div className={"col-12 col-md-2"} onKeyDown={handleKeyDown}>
                                <div>
                                    <OwLabel title={"route"} />
                                </div>
                                <TypeaheadFn
                                    lookupFn={lookupRoute}
                                    availableOptions={availableRoutes}
                                    selectedOptionFn={setRouteFilter}
                                    titleProp="name"
                                    valueProp="id"
                                    emitSelectionSetup={{ emitObject: true }}
                                    renderFn={(route: IRoute) => <div>{route.name}</div>}
                                    resetTypeahead={resetRouteTypeahead}
                                    resetTypeaheadCallbackFn={() => setResetRouteTypeahead(false)}
                                />
                            </div>

                            {/* Driver Filter */}
                            <div className={"col-12 col-md-2"} onKeyDown={handleKeyDown}>
                                <div>
                                    <OwLabel title={"driver"} />
                                </div>
                                <TypeaheadFn
                                    lookupFn={lookupDriver}
                                    availableOptions={availableDrivers}
                                    selectedOptionFn={setDriverFilter}
                                    titleProp="name"
                                    valueProp="id"
                                    emitSelectionSetup={{ emitObject: true }}
                                    renderFn={(user: IUser) => <div>{user.name}</div>}
                                    resetTypeahead={resetDriverTypeahead}
                                    resetTypeaheadCallbackFn={() => setResetDriverTypeahead(false)}
                                />
                            </div>

                            {/* Vehicle Filter (conditional) */}
                            {supplierModel.has_vehicles && (
                                <div className={"col-12 col-md-2"} onKeyDown={handleKeyDown}>
                                    <div>
                                        <OwLabel title={"vehicle"} />
                                    </div>
                                    <TypeaheadFn
                                        lookupFn={lookupVehicle}
                                        availableOptions={availableVehicles}
                                        selectedOptionFn={setVehicleFilter}
                                        titleProp="name"
                                        valueProp="id"
                                        emitSelectionSetup={{ emitObject: true }}
                                        renderFn={(vehicle: IVehicle) => <div>{vehicle.name}</div>}
                                        resetTypeahead={resetVehicleTypeahead}
                                        resetTypeaheadCallbackFn={() => setResetVehicleTypeahead(false)}
                                    />
                                </div>
                            )}

                            {/* Order Filter (simple text input) */}
                            <div className={"col-12 col-md-2"} onKeyDown={handleKeyDown}>
                                <div>
                                    <OwLabel title={"order"} />
                                </div>
                                <OwFnInput
                                    name="orderFilter"
                                    value={orderFilter}
                                    fn={(e: React.ChangeEvent<HTMLInputElement>) => setOrderFilter(e.target.value)}
                                />
                            </div>

                            {/* User Filter (created by) */}
                            <div className={"col-12 col-md-2"} onKeyDown={handleKeyDown}>
                                <div>
                                    <OwLabel title={"user"} />
                                </div>
                                <TypeaheadFn
                                    lookupFn={lookupUser}
                                    availableOptions={availableUsers}
                                    selectedOptionFn={selectedUser}
                                    selectedOption={userFilter}
                                    titleProp="name"
                                    valueProp="id"
                                    emitSelectionSetup={{ emitObject: true }}
                                    renderFn={renderAvailableUsers}
                                    resetTypeahead={resetTypeahead}
                                    resetTypeaheadCallbackFn={() => {
                                        setResetTypeahead(false);
                                    }}
                                />
                            </div>

                            {/* Date Range */}
                            <div className="col-12 col-md-4">
                                <div>
                                    <OwLabel title={"date_range"} />
                                </div>
                                <div>
                                    <OwDateRange
                                        className="flex-nowrap"
                                        startDateSelected={startDate?.toDate() ?? null}
                                        endDateSelected={endDate?.toDate() ?? null}
                                        startFn={(date: Moment | null) => {
                                            setStartDate(date);
                                        }}
                                        endFn={(date: Moment | null) => {
                                            setEndDate(date);
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Search/Reset Buttons */}
                            <div className="col-12 col-md-2 mt-2 mt-md-0 d-flex align-items-end">
                                <OwButton title={"search"} fn={() => getDailyRoutes()} />
                                <OwButton title={"reset"} fn={resetSearch} className={"ms-2 btn-danger"} />
                            </div>
                        </div>
                    </SearchSection>
                </div>
            )}

            <div>
                <OwActionBar
                    actions={actions}
                    columns={{}}
                    colToggledFn={() => {}}
                    toggleSmallTable={() => {}}
                    hideColumnToggle={true}
                    hideTableTypeSelect={true}
                />
            </div>

            <div className={"position-relative"}>
                <ConfirmDeleteOverlayFn
                    targetElem={targetElem}
                    handleConfirm={handleConfirm}
                    handleCancel={handleCancel}
                    leftAdjustment={0}
                    nestedParentElem={"daily-routes-table"}
                    skipMainView={true}
                />
                <OwFnTable
                    id={"daily-routes-table"}
                    columns={tableCols}
                    dataSet={dailyRoutes}
                    dataFetch={isDataFetching}
                    initialData={isInitialData}
                    currentSortCol={sortCol}
                />
            </div>

            <div className="mt-2">
                <PaginationBar offset={offset} limit={limit} totalRecords={totalDailyRoutes} onPaginationChanged={onPaginationChanged} />
            </div>

            {renderMapModal()}
        </div>
    );
};
